import api from '@/apis/di/budgetGroupItemAPI';
import CrudCache from '@/stores/crudBaseCache.js';
var crud = new CrudCache('budgetGroupItem', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_group_item',
    field: {
      key: 'budget_group_item_id',
      code: 'budget_group_item_code',
      name: 'budget_group_item_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
